import { defineCatalogue } from '../../i18n';

export type DurationUnit = 'minutes' | 'hours' | 'days' | 'weeks' | 'months';

export const durationCatalogue = defineCatalogue(
  {
    'unit.label': 'Unidade',
    'unit.minutes': 'minutos',
    'unit.hours': 'horas',
    'unit.days': 'dias',
    'unit.weeks': 'semanas',
    'unit.months': 'meses',
    'unit.minutes.one': '{count} minuto',
    'unit.minutes.other': '{count} minutos',
    'unit.hours.one': '{count} hora',
    'unit.hours.other': '{count} horas',
    'unit.days.one': '{count} dia',
    'unit.days.other': '{count} dias',
    'unit.weeks.one': '{count} semana',
    'unit.weeks.other': '{count} semanas',
    'unit.months.one': '{count} mês',
    'unit.months.other': '{count} meses',
    'error.min': 'Use pelo menos {min}.',
    'error.range': 'Use entre {min} e {max}.',
  },
  {
    'unit.label': 'Unit',
    'unit.minutes': 'minutes',
    'unit.hours': 'hours',
    'unit.days': 'days',
    'unit.weeks': 'weeks',
    'unit.months': 'months',
    'unit.minutes.one': '{count} minute',
    'unit.minutes.other': '{count} minutes',
    'unit.hours.one': '{count} hour',
    'unit.hours.other': '{count} hours',
    'unit.days.one': '{count} day',
    'unit.days.other': '{count} days',
    'unit.weeks.one': '{count} week',
    'unit.weeks.other': '{count} weeks',
    'unit.months.one': '{count} month',
    'unit.months.other': '{count} months',
    'error.min': 'Use at least {min}.',
    'error.range': 'Use between {min} and {max}.',
  },
);
